module.exports = __webpack_public_path__ + "img/shhy.7b8ee946.jpg";